// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__109ot","productName":"Table_productName__1wtdj"};